export default __webpack_public_path__ + "static/media/952.230a66b6.gif";